.dashboard-widget-icon {
  font-size: 40px;
  margin-left: 2px;
}
